import { Command } from 'ckeditor5/src/core';
import {
	COMPONENT_NAME,
	COMPONENT_TITLE,
	OUT_COMMANDS,
	COMPONENT_ATTR_ID,
	COMPONENT_ATTR_NAME
} from '../constants';
import { getSelectedText } from '../utils';
import { isEmpty } from 'lodash';

export default class EditableFieldCreateCommand extends Command {
	execute( data ) {
		const id = ( data && data.id ) || '';
		const name = ( data && data.value ) || '';
		const editor = this.editor;

		if ( isEmpty( name ) || isEmpty( id ) ) {
			return;
		}

		const selection = editor.model.document.selection;
		editor.model.change( writer => {
			const content = getSelectedText( editor ) || '';

			const field = createSimpleBox( selection, writer, id, name, content );

			editor.model.insertContent( field );
			editor.model.insertContent( writer.createText( ' ' ) );

			this.fire( OUT_COMMANDS.CREATE, { id, name, text: content } );

			writer.setSelection( field, 'on' );
		} );
	}

	refresh() {
		const model = this.editor.model;
		const selection = model.document.selection;
		const allowedIn = model.schema.findAllowedParent( selection.getFirstPosition(), COMPONENT_NAME );
		model.schema.addChildCheck( ( context, childDefinition ) => {
			if ( childDefinition.name == 'softBreak' && Array.from( context.getNames() ).includes( COMPONENT_TITLE ) ) {
				return false;
			}
		} );

		this.isEnabled = allowedIn !== null;
	}
}

function createSimpleBox( selection, writer, id, name, content ) {
	const customBox = writer.createElement( COMPONENT_NAME, {
		...Object.fromEntries( selection.getAttributes() ),
		[ `${ COMPONENT_ATTR_ID }` ]: id,
		[ `${ COMPONENT_ATTR_NAME }` ]: name
	} );

	const simpleBoxTitle = writer.createElement( COMPONENT_TITLE, {
		restrictedEditingException: true
	} );

	const innerText = writer.createText( content );

	writer.append( simpleBoxTitle, customBox );
	writer.append( innerText, simpleBoxTitle );

	return customBox;
}
